import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { ThemeProvider } from "./Components/ThemeContext";
import Navbar from "./Components/Navbar/Navbar";
import Footer from "./Components/Footer/Footer";

// ── Core Pages ──
import HomePage from "./Components/HomePage/Homepage";
import AboutUsSection from "./Components/AboutUs/AboutUsPage";
import Testimonial from "./Components/Testimonials/Testimonial";
import OurWorkSection from "./Components/OurWork/OurWorkSection";
import CaseStudyPage from "./Components/OurWork/CaseStudyPage";
import ContactPage from "./Components/ContactUs/ContactUs";
import Services from "./Components/OurServices/ServicesSection";
import CareerPage from "./Components/Career/CareerPage";
import PrivacyPolicy from "./Components/Footer/PrivacyPolicy";
import TermsOfService from "./Components/Footer/TermsOfService";
import ScrollToTopButton from "./Components/ScrollToTopButton/ScrollToTopButton";
import AIChatWidget from "./Components/AIChatWidget/AIChatWidget";

// ── Portal ──
import PortalLogin from "./Components/Portal/PortalLogin";

// ── Software Service Pages ──
import WebDevelopmentPage from "./Components/OurServices/WebDevelopmentPage";
import MobileAppDevelopmentPage from "./Components/OurServices/MobileAppDevelopmentPage";
import GraphicUIDesignPage from "./Components/OurServices/GraphicUIDesignPage";
import CustomSoftwareDevelopmentPage from "./Components/OurServices/CustomSoftwareDevelopmentPage";
import AIAutomationPage from "./Components/OurServices/AIAutomationPage";
import IoTPage from "./Components/OurServices/IoTPage";
import EmbeddedSystemsPage from "./Components/OurServices/EmbeddedSystemsPage";
import RoboticsPage from "./Components/OurServices/RoboticsPage";
import PCBDesignPage from "./Components/OurServices/PCBDesignPage";
import SmartHomePage from "./Components/OurServices/SmartHomePage";

// ── Routes that hide Navbar + Footer ──
const NAKED_ROUTES = ["/portal"];

function AppLayout() {
  const location = useLocation();
  const isNaked = NAKED_ROUTES.includes(location.pathname);

  return (
    <div
      className="min-h-screen flex flex-col"
      style={{
        backgroundColor: "var(--bg)",
        color: "var(--text)",
        transition: "background-color 0.4s, color 0.4s",
      }}
    >
      {!isNaked && <Navbar />}

      <main className="flex-grow">
        <Routes>

          {/* ── Core Pages ── */}
          <Route path="/"                element={<HomePage />} />
          <Route path="/about-us"        element={<AboutUsSection />} />
          <Route path="/testimonials"    element={<Testimonial />} />
          <Route path="/portfolio"       element={<OurWorkSection />} />
          <Route path="/portfolio/:slug" element={<CaseStudyPage />} />
          <Route path="/contact-us"      element={<ContactPage />} />
          <Route path="/services"        element={<Services />} />

          {/* ── Portal (no navbar/footer) ── */}
          <Route path="/portal" element={<PortalLogin />} />

          {/* ── Software Service Pages ── */}
          <Route path="/web-development"             element={<WebDevelopmentPage />} />
          <Route path="/mobile-app-development"      element={<MobileAppDevelopmentPage />} />
          <Route path="/ui-ux-design"                element={<GraphicUIDesignPage />} />
          <Route path="/custom-software-development" element={<CustomSoftwareDevelopmentPage />} />
          <Route path="/ai-automation"               element={<AIAutomationPage />} />

          {/* ── Engineering Service Pages ── */}
          <Route path="/engineering/iot"              element={<IoTPage />} />
          <Route path="/engineering/embedded-systems" element={<EmbeddedSystemsPage />} />
          <Route path="/engineering/robotics"         element={<RoboticsPage />} />
          <Route path="/engineering/pcb-design"       element={<PCBDesignPage />} />
          <Route path="/engineering/smart-home"       element={<SmartHomePage />} />

          {/* ── Other Pages ── */}
          <Route path="/careers"          element={<CareerPage />} />
          <Route path="/privacy-policy"   element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />

        </Routes>
      </main>

      {!isNaked && <Footer />}
      {!isNaked && <ScrollToTopButton />}
      {!isNaked && <AIChatWidget />}
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ThemeProvider>
          <AppLayout />
        </ThemeProvider>
      </Router>
    </HelmetProvider>
  );
}

export default App;